export const CitizenshipOptions = [
  { label: '', value: '' },
  { label: 'Singaporean', value: 'singaporean' },
  { label: 'Singapore PR', value: 'pr' },
  { label: 'Singapore Pass Holder', value: 'passholders' },
  { label: 'Other Citizenship', value: 'others' }
]
